import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Flex,
  Spinner
} from '@chakra-ui/react';
import Cover from '../components/User/Cover';
import Main from '../components/User/Main';
import axiosInstance from '../utils/axiosInstance';
import axios from 'axios';

const UserPage = () => {
  const { user_id } = useParams();  // Get user_id from the URL if present
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(null);

  useEffect(() => {
    if (setLoaded > 1){
      console.log(userData)
      return;
    }
    const fetchUserData = async () => {
      try {
        const userType = localStorage.getItem('user_type');
        const token = localStorage.getItem('token');  // Check if token exists
        const backendUrl = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_BACKEND_URL
  : 'http://localhost:8080';
        const endpoint = user_id ? `${backendUrl}/user/${user_id}` : `${backendUrl}/user`;
    
        let response;
    
        if (token) {
          // Use axiosInstance with Authorization header if token exists
          response = await axiosInstance.get(endpoint, {
            headers: {
              userType: userType,
              Authorization: `Bearer ${token}`,  // Add token if it exists
            },
          });
        } else {
          // Use regular axios for public request without token
          response = await axios.get(endpoint, {
            headers: {
              userType: userType,  // No Authorization header if token is missing
            },
          });
        }
    
        // Set user data
        setUserData(response.data);
      } catch (err) {
        setError('Failed to fetch user data');
        console.error('Error fetching user data:', err);
      } finally {
        setLoading(false);
      }
    };
    
    console.log("See if 2x")
    fetchUserData();
    setLoaded(1)
  }, [user_id]);

  if (loading) {
    return (
      <Flex minH="100vh" alignItems="center" justifyContent="center">
        <Spinner size="xl" />
      </Flex>
      )
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (loading) {
    return (
    <Flex minH="100vh" alignItems="center" justifyContent="center">
      <Spinner size="xl" />
    </Flex>
    )
  }

  return (
    <div>
        <Cover coverImageUrl={userData.cover} userId={userData.id} isEditable={userData.editable}/>
        <Main userData={userData} setUserData={setUserData} isEditable={userData.editable} />
    </div>
  );
};

export default UserPage;
